export default __webpack_public_path__ + "static/media/australia_day_feature.d156cf42.png";